module.exports = {
	"id": "MU",
	"name": "Mauritius",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.017124,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.02854,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.097036,
			"23": null,
			"24": null,
			"25": 0.005708,
			"26": 0.062788,
			"27": null,
			"28": null,
			"29": 0.017124,
			"30": 0.005708,
			"31": 0.091328,
			"32": 0.022832,
			"33": 0.02854,
			"34": 0.102744,
			"35": 0.02854,
			"36": 0.05708,
			"37": 0.02854,
			"38": 0.039956,
			"39": 0.051372,
			"40": 0.045664,
			"41": 0.022832,
			"42": 0.022832,
			"43": 0.131284,
			"44": 0.074204,
			"45": 0.051372,
			"46": 0.045664,
			"47": 0.062788,
			"48": 0.062788,
			"49": 1.466956,
			"50": 0.131284,
			"51": 0.679252,
			"52": 0.382436,
			"53": 28.220352,
			"54": 6.861016,
			"55": 0.17124,
			"56": 0.034248,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.011416,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.005708,
			"12": 0.017124,
			"13": 0.005708,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.017124,
			"19": null,
			"20": null,
			"21": 0.005708,
			"22": 0.011416,
			"23": null,
			"24": 0.005708,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.005708,
			"30": 0.011416,
			"31": 0.034248,
			"32": 0.011416,
			"33": 0.017124,
			"34": null,
			"35": 0.011416,
			"36": 0.011416,
			"37": 0.02854,
			"38": 0.05708,
			"39": 0.074204,
			"40": 0.022832,
			"41": 0.022832,
			"42": 0.039956,
			"43": 0.11416,
			"44": 0.045664,
			"45": 0.068496,
			"46": 0.062788,
			"47": 0.39956,
			"48": 0.547968,
			"49": 6.016232,
			"50": 0.331064,
			"51": 0.022832,
			"52": null,
			"3.5": null,
			"3.6": 0.011416
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.005708,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": 0.039956,
			"35": 0.005708,
			"36": 0.022832,
			"37": 0.045664,
			"38": 0.011416,
			"39": 0.011416,
			"40": 0.747748,
			"41": 0.097036,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.02854
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.08562,
			"6": 0.017124,
			"7": 0.022832,
			"8": 0.119868,
			"9": 0.165532,
			"10": 0.719208,
			"3.1": null,
			"3.2": null,
			"5.1": 0.062788,
			"6.1": 0.022832,
			"7.1": 0.02854,
			"9.1": 0.673544
		},
		"ios_saf": {
			"8": 0,
			"10": 1.74026638551,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.046898165383,
			"8.1-8.4": 0.0866423733347,
			"9.0-9.2": 0.0413339762698,
			"9.3": 0.6306080995
		},
		"android": {
			"3": 0,
			"4": 0.0776511627907,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00970639534884,
			"4.1": 0.280098837209,
			"4.2-4.3": 0.700247093023,
			"4.4": 1.60571511628,
			"4.4.3-4.4.4": 1.61958139535
		},
		"ie": {
			"6": null,
			"7": 0.005708,
			"8": 0.268276,
			"9": 0.136992,
			"10": 0.182656,
			"11": 2.22612,
			"5.5": null
		},
		"op_mob": {
			"0": 0.555402249115,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0154278402532
		},
		"edge": {
			"12": 0.148408,
			"13": 0.54226,
			"14": 0.947528
		},
		"ie_mob": {
			"10": 0.143059690141,
			"11": 0.582457309859
		},
		"bb": {
			"7": 0.0193185,
			"10": null
		},
		"samsung": {
			"0": 4.868262
		},
		"and_uc": {
			"0": 2.369736
		},
		"op_mini": {
			"0": 7.48283791063
		},
		"and_chr": {
			"0": 21.185448
		},
		"and_ff": {
			"0": 0.098739
		}
	},
	"total": 98.7507495
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/MU.json
 ** module id = 598
 ** module chunks = 0
 **/